export default function AdminActions({
                                         handleResetPasswordLink,
                                         handleVerifyEmailLink,
                                         handleDeleteAccount,
                                         registering,
                                         auth0Details,
                                         user,
                                         hasDeleteAccess,
                                         suppressionStatus,
                                         handleUnsuppress,
                                         isUnsuppressing,
                                         blockStatus,
                                         handleUnblockAccount,
                                         isUnblocking
                                     }) {
    const email = auth0Details?.email;
    const suppressionReasons = suppressionStatus?.reasons || [];
    const hasUnliftableReason = suppressionReasons.some(reason => /cannot be lifted/i.test(reason));

    return (
        <div>
            <h4
                id="sub_head"
                style={{
                    fontFamily: "A Love of Thunder",
                    color: "#007935",
                    marginBottom: "10px"
                }}
            >
                Admin Controls
            </h4>

            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px"
                }}
            >
                <div>
                    <h6 id="note">
                        Send password reset link to the customer's email
                    </h6>

                    <div
                        className="form-group"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <input
                            type="text"
                            className="form-control"
                            value={email || "Email not found to send link."}
                            readOnly
                        />

                        <button
                            type="button"
                            id="sub_btn"
                            onClick={handleResetPasswordLink}
                            disabled={registering}
                            style={{
                                backgroundColor: "#137c00",
                                height: "35px",
                                fontSize: "1.2em",
                                whiteSpace: "nowrap",
                                width: "200px"
                            }}
                        >
                            Reset Password {" "}
                            {registering && (
                                <i className="fa fa-spinner fa-spin" />
                            )}
                        </button>
                    </div>
                </div>

                <hr style={{ margin: 0 }} />

                <div>
                    <h6 id="note">
                        Send email verification link to the customer
                    </h6>

                    <div
                        className="form-group"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <input
                            type="text"
                            className="form-control"
                            value={email || "Email not found to send link."}
                            readOnly
                        />

                        <button
                            type="button"
                            id="sub_btn"
                            onClick={handleVerifyEmailLink}
                            disabled={registering}
                            style={{
                                backgroundColor: "#137c00",
                                height: "35px",
                                fontSize: "1.2em",
                                whiteSpace: "nowrap",
                                width: "200px"
                            }}
                        >
                            Verify Email Link{" "}
                            {registering && (
                                <i className="fa fa-spinner fa-spin" />
                            )}
                        </button>
                    </div>
                </div>

                {!!suppressionStatus?.suppressed && (
                    <>
                        <hr style={{ margin: 0 }} />

                        <div>
                            <h6 id="note" className="text-danger">
                                Email marketing suppressed: {suppressionReasons.join("; ") || "Unknown reason"}
                            </h6>

                            {hasUnliftableReason ? (
                                <div className="text-danger">
                                    This suppression cannot be lifted here. Please correct the customer's email in
                                    the Update tab.
                                </div>
                            ) : (
                                <div
                                    className="form-group"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}
                                >
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={suppressionStatus?.email || "Email not found."}
                                        readOnly
                                    />

                                    <button
                                        type="button"
                                        id="sub_btn"
                                        onClick={handleUnsuppress}
                                        disabled={isUnsuppressing}
                                        style={{
                                            backgroundColor: "#137c00",
                                            height: "35px",
                                            fontSize: "1.2em",
                                            whiteSpace: "nowrap",
                                            width: "200px"
                                        }}
                                    >
                                        Unsuppress{" "}
                                        {isUnsuppressing && (
                                            <i className="fa fa-spinner fa-spin" />
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {!!blockStatus?.isBlocked && (
                    <>
                        <hr style={{ margin: 0 }} />

                        <div>
                            <h6 id="note" className="text-danger">
                                {blockStatus?.message || "Account is blocked"}
                            </h6>

                            <div
                                className="form-group"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px"
                                }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user?.customerId || "Customer ID not found."}
                                    readOnly
                                />

                                <button
                                    type="button"
                                    id="sub_btn"
                                    onClick={handleUnblockAccount}
                                    disabled={isUnblocking}
                                    style={{
                                        backgroundColor: "#137c00",
                                        height: "35px",
                                        fontSize: "1.2em",
                                        whiteSpace: "nowrap",
                                        width: "200px"
                                    }}
                                >
                                    Unblock{" "}
                                    {isUnblocking && (
                                        <i className="fa fa-spinner fa-spin" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </>
                )}

                <hr style={{ margin: 0 }} />

                {!!hasDeleteAccess && (
                    <div>
                        <h6 id="note">Admin delete action</h6>

                        <div
                            className="form-group"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <input
                                type="text"
                                className="form-control"
                                value={user?.email || "Account not found."}
                                readOnly
                            />

                            <button
                                type="button"
                                id="sub_btn"
                                onClick={handleDeleteAccount}
                                disabled={registering}
                                style={{
                                    backgroundColor: "#dc3545",
                                    height: "35px",
                                    fontSize: "1.2em",
                                    whiteSpace: "nowrap",
                                    width: "200px"
                                }}
                            >
                                Delete Account{" "}
                                {registering && (
                                    <i className="fa fa-spinner fa-spin" />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}